/* eslint-disable max-len */
import React, { FC, useEffect } from 'react'

import '../pages-management/styles.scss'
import { useDispatch, useSelector } from 'react-redux'

import StartPage from './start-page/StartPage'
import Confirmation from './confirmation/Confirmation'
import { showHeader } from '../../store/general/actions'
import { useHistory, useParams } from 'react-router-dom'
import { requestLinkDetails } from '../../store/meeting-page/actions'
import { Routes } from '../../routing/routes'
import { Plann3rStore } from '../../store/types'
import PickAMoment from './pick-a-moment/PickAMoment'

import './styles.scss'

const MeetingPage: FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { company, pageName } = useParams<{
    company: string,
    pageName: string,
  }>()
  
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { response_received, moment_picking } = useSelector((state: Plann3rStore) => state.meetingPage)

  useEffect(() => {
    if (
      company !== '' &&
      company !== undefined &&
      pageName !== '' &&
      pageName !== undefined
    ) {
      dispatch(requestLinkDetails(company, pageName))
      dispatch(showHeader(false))

      // TODO: don't use linkUpdateName/linkUpdateEmail => use linkUpdateValue instead
      // => requires fields being loaded, so after requestLinkDetails
      /**
      const first = new URLSearchParams(window.location.search).get('first')
      const last = new URLSearchParams(window.location.search).get('last')
      const em = new URLSearchParams(window.location.search).get('email')

      if (first && last) dispatch(linkUpdateName(first + ' ' + last))
      if (em) dispatch(linkUpdateEmail(em))
       */
    } else {
      alert('Invalid page URL.')
      history.push(Routes.HOME)
    }

    /**
    // INJECT PIXEL
    if (pixel) {
      ReactPixel.init(pixel, undefined, {
        autoConfig: true, // set pixel's autoConfig
        debug: false, // enable logs
      })
      ReactPixel.pageView()
    }

    // INJECT GA
    if (ga) {
      let script = document.createElement('script')
      script.setAttribute('type', 'text/javascript')
      script.innerHTML =
        '(function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new
        Date();const a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=const g;m.parentNode.insertBefore(a,m)})(window,document,\
        'script\',\'https://www.google-analytics.com/analytics.js\',\'ga\');ga(\'create\', ' +
        ga +
        ', \'auto\');ga(\'send\', \'pageview\');'
      document.body.appendChild(script)
    }

    // INJECT CSS
    if (css) {
      let style = document.createElement('style')
      style.innerHTML = css
      document.body.appendChild(style)
    }

    // INJECT JS
    if (js) {
      let script = document.createElement('script')
      script.setAttribute('type', 'text/javascript')
      script.innerHTML = js
      document.body.appendChild(script)
    }
     */
  }, [company, pageName, dispatch, history])
  
  if (response_received) {
    return <div className="meetingPage"><Confirmation /></div>
  }

  if (moment_picking) {
    return (
      <div className="meetingPage"><PickAMoment /></div>
    )
  }

  return <div className="meetingPage"><StartPage /></div>
}

export default MeetingPage
